import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../../../Shared/colors";
import { useGetAllProjectsQuery } from "../../../../features/projectSlice";
import { SearchLeadsDataTable } from "./SearchLeadsDataTable";
import { toast, Toaster } from "react-hot-toast";
import { decryptData } from "../../../../services/crypto";
import { useGetTelesalesAssignmentsQuery } from "../../../../features/telesaleleadsSlice";
import { usePaginationFromURL } from "../../../../hooks/usePaginationFromURL";

export const SearchLeadsFirst = () => {
  let staffName = null;
  let storedStaffName = localStorage.getItem("staffName");

  if (storedStaffName) {
    try {
      staffName = decryptData(storedStaffName);
    } catch (error) {
      // Failed to decrypt data
    }
  }

  let staffId = null;
  let storedStaffId = localStorage.getItem("id");

  if (storedStaffId) {
    try {
      staffId = decryptData(storedStaffId);
    } catch (error) {
      // Failed to decrypt data
    }
  }

  let role = null;
  let storedStaffRole = localStorage.getItem("role");

  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      // Failed to decrypt data
    }
  }

  // Use URL-based pagination hook
  const { currentPage, pageSize, setPage: setCurrentPage, setPageSize: setpageSize } = usePaginationFromURL({
    defaultPage: 1,
    defaultPageSize: 10
  });
  const [isNewChecked, setIsNewChecked] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [kpiData, setkpiData] = useState({
    start: "",
    end: "",
    clientName: "",
    callStatus: "",
    leadID: "",
    employeeID: { id: staffId, label: staffName },
    project: "",
    phoneNumber: "",
    isNew: false,
  });
  const [searchFilters, setSearchFilters] = useState({
    start: "",
    end: "",
    clientName: "",
    callStatus: "",
    leadID: "",
    employeeID: { id: staffId, label: staffName },
    project: "",
    phoneNumber: "",
  });
  const [showAllData, setShowAllData] = useState(true);
  const [isSearchTriggered, setIsSearchTriggered] = useState(false);

  // const { data, isLoading, isFetching, refetch } = useGetTelesalesAssignmentsQuery({
  //   limit: pageSize,
  //   page: currentPage,
  //   startDate: isSearchTriggered ? kpiData.start : "",
  //   endDate: isSearchTriggered ? kpiData.end : "",
  //   phoneNumber: isSearchTriggered ? kpiData.phoneNumber : "",
  //   projectID: isSearchTriggered ? kpiData.project : "",
  //   leadID: isSearchTriggered ? kpiData.leadID : "",
  //   callStatus: isSearchTriggered ? kpiData.callStatus : "",
  //   clientName: isSearchTriggered ? kpiData.clientName : "",
  // }, {
  //   refetchOnMountOrArgChange: true
  // });

  const { data, isLoading, isFetching, refetch } = useGetTelesalesAssignmentsQuery(
    {
      limit: pageSize,
      page: currentPage,
      ...(showAllData ? {} : searchFilters),
    },
    {
      skip: !isSearchTriggered && !showAllData,
      refetchOnMountOrArgChange: true,
    }
  );



  const handleCheckboxChange = (event) => {
    setIsNewChecked(event.target.checked);
    handleSearch();
  };

  // const [trigger, { data: leadData, isFetching, error }] =
  //   useLazySearchLeadsFilterQuery();

  const { data: project } = useGetAllProjectsQuery();




  const handleChange = (e) => {
    const { name, value } = e.target;

    setkpiData({
      ...kpiData,
      [name]: value,
    });
  };

  // const handleSearch = () => {
  //   setIsSearchTriggered(true);
  //   if (!isInitialLoad) {
  //     toast.loading("Searching leads...", { duration: 1000 });
  //   }
  //   setIsInitialLoad(false);
  //   // Force refetch to ensure backend is hit even if filters are unchanged
  //   refetch();
  // };

  const handleSearch = () => {
    setSearchFilters({
      startDate: kpiData.start || "",
      endDate: kpiData.end || "",
      phoneNumber: kpiData.phoneNumber || "",
      projectID: kpiData.project || "",
      leadID: kpiData.leadID || "",
      callStatus: kpiData.callStatus || "",
      clientName: kpiData.clientName || "",
    });

    setShowAllData(false);
    setIsSearchTriggered(true);

    toast.loading("Searching leads...", { duration: 1000 });

    setTimeout(() => refetch(), 100);
  };


  const handleResetFilters = () => {
    setkpiData({
      start: "",
      end: "",
      clientName: "",
      callStatus: "",
      leadID: "",
      employeeID: { id: staffId, label: staffName },
      project: "",
      phoneNumber: "",
      isNew: false,
    });

    setSearchFilters({});
    setShowAllData(true);
    setIsSearchTriggered(true);
    toast.success("Filters reset successfully!");

    setTimeout(() => refetch(), 100);
  };

  useEffect(() => {
    if (isInitialLoad) {
      setIsSearchTriggered(true);
    }
  }, [isInitialLoad]);


  return (
    <>
      <Main>
        <SearchContainer>
          <SearchHeader>
            <SearchTitle>
              <SearchIcon>🔍</SearchIcon>
              Search Telesale Leads
              {/* {(isLoading || isFetching) && (
                <LoadingIndicator>
                  <Spinner />
                  <span>Loading...</span>
                </LoadingIndicator>
              )} */}
            </SearchTitle>
          </SearchHeader>

          <SearchForm>
            <FormRow>
              <FormGroup>
                <FormLabel>Start Date</FormLabel>
                <DateInput
                  type="date"
                  name="start"
                  id="start"
                  value={kpiData.start}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>End Date</FormLabel>
                <DateInput
                  type="date"
                  name="end"
                  id="end"
                  value={kpiData.end}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Phone Number</FormLabel>
                <TextInput
                  type="tel"
                  name="phoneNumber"
                  id="phoneNumber"
                  value={kpiData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Enter phone number"
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Project</FormLabel>
                <SelectInput
                  name="project"
                  id="project"
                  value={kpiData.project}
                  onChange={handleChange}
                >
                  <option value="">Select Project</option>
                  {project?.map((proj) => (
                    <option key={proj._id} value={proj._id}>{proj.projectName}</option>
                  ))}
                </SelectInput>
              </FormGroup>

              <FormGroup>
                <FormLabel>Lead ID</FormLabel>
                <TextInput
                  type="text"
                  name="leadID"
                  id="lead"
                  value={kpiData.leadID}
                  onChange={handleChange}
                  placeholder="Enter Lead ID"
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>Call Status</FormLabel>
                <SelectInput
                  name="callStatus"
                  id="callStatus"
                  value={kpiData.callStatus}
                  onChange={handleChange}
                >
                  <option value="">Select Call Status</option>
                  <option value="Call connected">Call Connected</option>
                  <option value="Call Not Connected">Call Not Connected</option>
                  <option value="followUp">Follow Up</option>
                  <option value="follow_up_sent">Follow Up Sent</option>
                  <option value="sms">SMS</option>
                  <option value="whatsapp">Whatsapp</option>
                  <option value="meeting_completed">Meeting Completed</option>
                </SelectInput>
              </FormGroup>


              <FormGroup>
                <FormLabel>Client Name</FormLabel>
                <TextInput
                  type="text"
                  name="clientName"
                  id="clientName"
                  value={kpiData.clientName}
                  onChange={handleChange}
                  placeholder="Type client name to search"
                />
              </FormGroup>
            </FormRow>

            <ActionRow>
              <SearchButton onClick={handleSearch} disabled={isLoading || isFetching}>
                {isLoading || isFetching ? (
                  <>
                    <Spinner />
                    {isLoading ? "Loading..." : "Searching..."}
                  </>
                ) : (
                  <>
                    <SearchIcon>🔍</SearchIcon>
                    Search Leads
                  </>
                )}
              </SearchButton>

              <ResetButton onClick={handleResetFilters} disabled={isLoading || isFetching}>
                <ResetIcon>🔄</ResetIcon>
                Reset Filters
              </ResetButton>
            </ActionRow>
          </SearchForm>
        </SearchContainer>
      </Main>
      <Toaster />
      <SearchLeadsDataTable
        leads={data || { assignments: [] }}
        pageSize={pageSize}
        setPageSize={setpageSize}
        setPage={setCurrentPage}
        checked={isNewChecked}
        handleCheckboxChange={handleCheckboxChange}
        isFetching={isLoading || isFetching}
        currentPage={currentPage}
        totalPages={data?.totalPages || 0}
        refetch={refetch}
      />
    </>
  );
};

const Main = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0.75rem;
`;

const SearchContainer = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  box-shadow: 
    0 4px 20px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    z-index: 1;
  }
`;

const SearchHeader = styled.div`
  padding: 1rem 1.25rem 0.5rem 1.25rem;
  border-bottom: 1px solid ${colors.inputBorderWhite};
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
`;

const SearchTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${colors.text};
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
`;

const SearchIcon = styled.span`
  font-size: 1.25rem;
  filter: grayscale(0.2);
`;

const LoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 1rem;
  color: ${colors.brown};
  font-size: 0.9rem;
  font-weight: 500;
  
  span {
    font-size: 0.8rem;
  }
`;

const SearchForm = styled.div`
  padding: 1rem 1.25rem 1.25rem 1.25rem;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

const FormLabel = styled.label`
  color: ${colors.text};
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.1rem;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const TextInput = styled.input`
  padding: 8px 12px;
  border: 1px solid ${colors.inputBorderWhite};
  border-radius: 8px;
  background-color: ${colors.white};
  color: ${colors.text};
  font-size: 0.8rem;
  transition: all 0.2s ease;
  outline: none;
  height: 36px;
  
  &:focus {
    border-color: ${colors.brown};
    box-shadow: 0 0 0 2px rgba(36, 147, 147, 0.1);
  }
  
  &::placeholder {
    color: ${colors.inputFeild};
    font-size: 0.75rem;
  }
  
  &:hover {
    border-color: ${colors.brown};
  }
`;

const DateInput = styled.input`
  padding: 8px 12px;
  border: 1px solid ${colors.inputBorderWhite};
  border-radius: 8px;
  background-color: ${colors.white};
  color: ${colors.text};
  font-size: 0.8rem;
  transition: all 0.2s ease;
  outline: none;
  height: 36px;
  
  &:focus {
    border-color: ${colors.brown};
    box-shadow: 0 0 0 2px rgba(36, 147, 147, 0.1);
  }
  
  &:hover {
    border-color: ${colors.brown};
  }
`;

const SelectInput = styled.select`
  padding: 8px 12px;
  border: 1px solid ${colors.inputBorderWhite};
  border-radius: 8px;
  background-color: ${colors.white};
  color: ${colors.text};
  font-size: 0.8rem;
  transition: all 0.2s ease;
  outline: none;
  cursor: pointer;
  height: 36px;
  
  &:focus {
    border-color: ${colors.brown};
    box-shadow: 0 0 0 2px rgba(36, 147, 147, 0.1);
  }
  
  &:hover {
    border-color: ${colors.brown};
  }
  
  option {
    padding: 6px;
    font-size: 0.8rem;
  }
`;


const ActionRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${colors.inputBorderWhite};
`;

const SearchButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 20px;
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  color: ${colors.white};
  border: none;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(36, 147, 147, 0.3);
  min-width: 140px;
  justify-content: center;
  height: 36px;
  
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(36, 147, 147, 0.4);
    background: linear-gradient(135deg, #1a6b6b 0%, ${colors.brown} 100%);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

const ResetButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 20px;
  background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
  color: ${colors.white};
  border: none;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(107, 114, 128, 0.3);
  min-width: 140px;
  justify-content: center;
  height: 36px;
  
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(107, 114, 128, 0.4);
    background: linear-gradient(135deg, #4b5563 0%, #6b7280 100%);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

const ResetIcon = styled.span`
  font-size: 1rem;
  filter: grayscale(0.2);
`;

const Spinner = styled.div`
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid ${colors.white};
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
